var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAgenda(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.813 10.25a.75.75 0 0 1 .75.75v.858h3.086a.75.75 0 0 1 .75.75V29a.75.75 0 0 1-.75.75H10.35A.75.75 0 0 1 9.6 29V12.608a.75.75 0 0 1 .75-.75h3.086V11a.75.75 0 0 1 1.5 0v.858h10.126V11a.75.75 0 0 1 .75-.75zm-12.376 3.108v.878a.75.75 0 0 0 1.5 0v-.878h10.126v.878a.75.75 0 0 0 1.5 0v-.878h2.336V28.25H11.1V13.358h2.336zm1.926 7.307a1.994 1.994 0 1 0 0-3.988 1.994 1.994 0 0 0 0 3.988z",
    fill: "#1D1D1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgenda);
export default __webpack_public_path__ + "static/media/icon-agenda.39231765.svg";
export { ForwardRef as ReactComponent };